import { Component } from 'react';
import { Navigate } from 'react-router-dom';

import { Button } from '@mui/material';
import { withTranslation } from 'react-i18next';
import i18n from '../assets/locales';


import '../assets/css/verification.css';


import Layout from '../layouts/layout.component';

import UserService from '../services/user.service';


type Props = {};

type State = {
  redirect: string | null,
  userUuid: string,
  username: string,
  success: boolean,
  errCode: number
};


class AccountVerification extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.routeToSignin = this.routeToSignin.bind(this);

    this.resendEmailVerification = this.resendEmailVerification.bind(this);

    this.state = {
      redirect: null,
      userUuid: '',
      username: '',
      success: false,
      errCode: 0,
    };
  }

  componentDidMount() {
    const url = window.location.href;
    const urlParts = url.split('/');
    const uuid = urlParts[urlParts.length - 2];
    const token = urlParts[urlParts.length - 1];

    // console.log(`AccountVerification:: uuid: ${uuid}, token: ${token}`);

    if (uuid && token) {
      this.setState({ userUuid: uuid });

      UserService.verifyEmail(uuid, token).then(
        (res) => {
          console.log(`Verification successful: ${JSON.stringify(res, null, 2)}`);

          let username = '';

          if (res && res.username) {
            username = res.username;
          }
          
          this.setState({
            success: true,
            username: username,
            errCode: 0,
          });
        },
        (err) => {
          console.error(`Verification failed: ${JSON.stringify(err, null, 2)}`);

          this.setState({
            success: false,
            username: '',
            errCode: err.status || -1,
          });
        }
      );
    } else {
      this.setState({
        success: false,
        errCode: -1,
      });
    }
  }

  componentWillUnmount() {
    
  }

  routeToSignin() {
    this.setState({
      redirect: '/signin'
    });
  }

  resendEmailVerification() {
    console.log('Resend verification email');

    const userUuid = this.state.userUuid;

    UserService.resendVerificationEmail(userUuid).then(
      (res) => {
        console.log(`Resend successful: ${JSON.stringify(res, null, 2)}`);
      },
      (err) => {
        console.error(`Resend failed: ${JSON.stringify(err, null, 2)}`);
      }
    );
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    return (
      <Layout>
        <div style={{ padding: 20 }}>
          { this.state.success ? (
              <>
                {/* <h1>Account Verified</h1> */}
                <p style={{ fontSize: '1.6rem', fontWeight: 'bold' }}>Thanks for joining SquareGolf, {this.state.username} !</p>
                {/* <p style={{ fontSize: '1.2rem' }}>Authentication process has been completed.</p> */}
                {/* <p style="font-size: 0.8rem;">[<%= message %>]</p> */}

                <div style={{ textAlign: 'center', lineHeight: '0.7em' }}>
                  {/* <!-- https://www.compart.com/en/unicode --> */}
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>&#x6B22;&#x8FCE;&#x5149;&#x4E34;</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>Willkommen</p>
                  <p>&nbsp;</p>
                  <p style={{ color: '#379684', fontSize: '3.0rem', fontWeight: 'bold', fontStretch: '120%' }}>Welcome</p>
                  <p>&nbsp;</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>Bienvenue</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>&#x0938;&#x094D;&#x0935;&#x093E;&#x0917;&#x0924;</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>Benvenuti</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>Selamat Datang</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>&#x3088;&#x3046;&#x3053;&#x305D;</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>&#xD658;&#xC601;&#xD569;&#xB2C8;&#xB2E4;</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>Bem-vindos</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>&#x0434;&#x043E;&#x0431;&#x0440;&#x043E;&#x0301; &#x043F;&#x043E;&#x0436;&#x0430;&#x0301;&#x043B;&#x043E;&#x0432;&#x0430;&#x0442;&#x044C;</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>Bievenido</p>
                  <p style={{ color: '#379684', fontSize: '1.0rem' }}>&#x0E22;&#x0E34;&#x0E19;&#x0E14;&#x0E35;&#x0E15;&#x0E49;&#x0E2D;;&#x0E19;&#x0E23;&#x0E31;&#x0E1A;</p>
                  <p style={{ color: '#379684', fontSize: '1.4rem' }}>&#x0111;&#x01B0;&#x01EE3;&#x0063; &#x0068;&#x006F;&#x0061;&#x006E; &#x006E;&#x0067;&#x0068;&#x00EA;&#x006E;&#x0068; &#x0111;&#x00F3;&#x006E;</p>
                </div>
                <p>&nbsp;</p>
                <div style={{ textAlign: 'center' }}>
                  <button className='round-btn' onClick={this.routeToSignin}>Sign In</button>
                </div>
              </>
            ) : this.state.errCode === 409 ? (
              <>
                <h1>Account already verified</h1>
                <p>&nbsp;</p>
                <p>Your account has been verified already.</p>
                <p>Please proceed to sign in.</p>
                <p>&nbsp;</p>
                <div style={{ textAlign: 'center' }}>
                  <button className='round-btn' onClick={this.routeToSignin}>Sign In</button>
                </div>
              </>
            ) : this.state.errCode === 410 ? (
              <>
                <h1>Account Verification Failed</h1>
                <p>The verification link is invalid or has expired. Please request a new verification email or contact our support team for assistance.</p>

                <Button 
                  className='btn btn-custom btn-sm btn-block w-80'
                  style={{border: '1px solid rgb(0, 96, 0)'}}
                  onClick={this.resendEmailVerification}>
                  <span>Resend Verification Email</span>
                </Button>
              </>
            ) : (
              <>
                <h1>Account Verification Failed</h1>
                <p>
                  An unexpected error occurred during account verification. Please try again later or contact our support team for assistance.
                </p>
              </>
            )
          }
        </div>
      </Layout>
    );
  }
}

export default withTranslation()(AccountVerification);
